// extracted by mini-css-extract-plugin
export var alertIcon = "_qg-0";